import React, { Component } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { inject, observer } from 'mobx-react';
import {translate} from 'react-i18next';
import i18n from '../../../i18n';

const heroVideoMp4 = require('../../../static/videos/home-hero.mp4');
const heroVideoWebM = require('../../../static/videos/home-hero.webm');

import Bumpometer from './Bumpometer';
import PizzaMess from './PizzaMess';
import Controls from './Controls';
import TimeStamp from './TimeStamp';
import { HeroUILayout, FakeZoomer, LoadingWrapper, HeroHeaderCopy, HeroStamp } from './styled-components';
import{ H1 } from '../../global/typography/typography';

import BlackPizza from '../../../static/svgs/black-pizza.svg';

@inject("store")
@observer class HomeHero extends Component {
  constructor(props) {
    super(props);

    this.stage1Frame = 6;
    this.stage2Frame = 24;
    this.stage3Frame = 34;
    this.stage4Frame = 42;

    this.numberOfTicks = 0;

    this.state = {
      currentStage: 0,
      timeDate: null,
      timeTime: null,
      interaction: false,
      controls: false,
      loading: true,
      lineData: 0
    }

    this.readyStateInterval = null;
    this.loading = false;
    this.oldFrame = null;
    this.oldStage = 1;
    this.stageClick = this.stageClick.bind(this);
    this.onTimeUpdate = this.onTimeUpdate.bind(this);
    this.jumpTo = this.jumpTo.bind(this);
    this.startVideo = this.startVideo.bind(this);
  }
  componentDidMount() {
    this.setState({
      timeDate: this.props.lng === 'en' ? moment().format("MMM.DD.YY") : moment().locale('es').format("MMMDD.YY"),
      timeTime: moment().format("h:mm a")
    })
    setInterval(() => {
        const timeTime = moment().format("h:mm a");
        this.setState({
          timeTime: timeTime
        })
    }, 30000);
    this.homeHeroVideo.addEventListener('canplaythrough', this.startVideo);
    this.readyStateInterval = setInterval(() => {
      if(this.homeHeroVideo.readyState === 1 && !this.loading) {
        this.homeHeroVideo.load();
        this.loading = true;
        }
    }, 300);
    if(this.homeHeroVideo.readyState > 3) {
      this.homeHeroVideo.pause();
      this.startVideo();
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.lng !== prevProps.lng) {
      this.setState({
        timeDate: this.props.lng === 'en' ? moment().format("MMM.DD.YY") : moment().locale('es').format("MMMDD.YY"),
      })
    }
  }
  startVideo() {
    clearInterval(this.readyStateInterval);
    this.setState({
      loading: false
    });
    const vidPromise = this.homeHeroVideo.play();
  }
  onTimeUpdate(e) {
    const videoFrame = Math.round(e.target.currentTime);
    if(videoFrame === 24) {
      this.setState({
        lineData: 1.3
      });
    } else if(videoFrame === 34) {
      this.setState({
        lineData: 1.3
      });
    } else if(videoFrame === 36) {
      this.setState({
        lineData: 1.3
      });
    } else if(videoFrame === 42) {
      this.setState({
        lineData: 1.3
      });
    } else if(videoFrame === 43) {
      this.setState({
        lineData: 1.35
      });
    } /* else if(videoFrame === 45) {
      this.setState({
        lineData: 1.3
      });
    } */ else {
      if(this.state.lineData !== null) {
        this.setState({
          lineData: null
        })
      }
    }
    switch(this.state.currentStage) {
      case 0:
        if(videoFrame >= this.stage1Frame) {
          this.setState({
            currentStage: 1,
            controls: true,
          });
        }
        break;
      case 1:
        if(videoFrame >= this.stage2Frame) {
          this.homeHeroVideo.currentTime = this.stage1Frame;
        }
        break;
      case 2:
        if(videoFrame >= this.stage3Frame) {
          this.homeHeroVideo.currentTime = this.stage2Frame;
        }
        break;
      case 3:
        if(videoFrame >= this.stage4Frame) {
          this.homeHeroVideo.currentTime = this.stage3Frame;
        }
        break;
      case 4:
        if(videoFrame >= Math.round(this.homeHeroVideo.duration)) {
          this.homeHeroVideo.currentTime = this.stage4Frame;
        }
        break;
    }
  }
  jumpTo(stage) {
    this.oldStage = this.state.currentStage;
    this.setState({
      currentStage: stage
    });
    switch(stage) {
      case 1:
        this.homeHeroVideo.currentTime = this.stage1Frame;
        break;
      case 2:
        this.homeHeroVideo.currentTime = this.stage2Frame;
        break;
      case 3:
        this.homeHeroVideo.currentTime = this.stage3Frame;
        break;
      case 4:
        this.homeHeroVideo.currentTime = this.stage4Frame;
        break;
    }
  }
  stageClick(e) {
    const stage = parseInt(e.currentTarget.getAttribute('data-stage'));
    if(this.state.interaction === false) {
      this.setState({
        interaction: true
      });
    }
    this.jumpTo(stage);
    const conditions = ['mild', 'moderate', 'critical', 'catastrophic'];
    window.dataLayer.push({
      'event': 'road-condition:click',
      'condition': conditions[stage - 1]
    });
  }

  render() {
    const { data, store, t, lng } = this.props;

    console.log('currentStage', this.state.currentStage)

    return (
      <div>
        <div style={{
          width: '100%',
          paddingTop: `${store.isMobile ? 'calc((10/7) * 100%)' : 'calc((9/16) * 100%)'}`,
          position: 'relative',
          overflow: 'hidden'
        }}>
          { this.state.loading &&
            <LoadingWrapper>
              <div className="pizzaHolder">
                <BlackPizza />
              </div>
              <div className="loading">{t('homeHero.loadingText')}</div>
            </LoadingWrapper>
          }
          <FakeZoomer className={`${this.state.interaction ? 'zoomed': ''}`}>
            <div className="top"></div>
            <div className="left"></div>
            <div className="right"></div>
            <div className="bottom"></div>
          </FakeZoomer>
          <video
            ref={(video) => { this.homeHeroVideo = video }}
            width={`${store.isMobile ? '255%' : '100%)'}`}
            height="auto"
            muted
            playsInline
            preload
            style={{
              position: 'absolute',
              top: 0,
              bottom: 0,
              right: 0,
              left: `${store.isMobile ? '-84%' : '0'}`
            }}
            onTimeUpdate={this.onTimeUpdate}
          >
            {/*<source src={heroVideoWebM} type='video/webm' />*/}
            <source src={heroVideoMp4} type="video/mp4" />
          </video>
          <HeroUILayout lang={lng} interaction={this.state.interaction} controls={this.state.controls}>
            { !store.isMobile &&
              <span>
                <TimeStamp timeValue={this.state.timeDate} direction={'left'} />
                <TimeStamp timeValue={this.state.timeTime} direction={'right'} />
              </span>
            }
            { !store.isMobile &&
              <Bumpometer currentStage={this.state.currentStage} label={t('homeHero.impactMeterLabel')} lineData={this.state.lineData} isMobile={store.isMobile} />
            }
            { !store.isMobile &&
              <PizzaMess currentStage={this.state.currentStage} label={t('homeHero.pizzaDamageLabel')} />
            }
            <Controls currentStage={this.state.currentStage} stageClick={this.stageClick} oldStage={this.oldStage} isMobile={store.isMobile} />
            <div className="controlLabel">{t('homeHero.controlLabel')}</div>
          </HeroUILayout>
          <HeroHeaderCopy in={this.state.controls && !this.state.interaction}>
            <H1 color={'red'}>{t('homeHero.introCopy')}</H1>
          </HeroHeaderCopy>
          <HeroStamp in={this.state.controls && !this.state.interaction}>
            {t('homeHero.stamp')}
          </HeroStamp>
        </div>
      </div>
    )
  }
}

export default translate()(HomeHero);



// WEBPACK FOOTER //
// ./src/components/modules/HomeHero/HomeHero.js